__turbopack_context__.v({
  "className": "lobster_b0c0b76f-module__yAvUiW__className",
});
